import React, { useState, useEffect } from 'react';
import {
  Table,
  Input,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
  Button
} from 'reactstrap';
import PaginationComponent from './Pagination';
import './faceDetections.css';
import { useNavigate } from "react-router-dom";

const FaceDetectionsTable = ({ data, handleImageClick }) => {

  const roleName = JSON.parse(localStorage.getItem('role'))

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState('All');
  const [timeFilter, setTimeFilter] = useState('');

  const navigate = useNavigate();

  // First filter by search term to get base filtered data
  const searchFilteredData = data.filter(item =>
    item.employee_id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get camera positions based on search results
  const cameraPositions = ['All', ...new Set(searchFilteredData.map(item => item.camera_position_no))];

  useEffect(() => {
    const filtered = data.filter(item => {
      const matchesSearch = item.employee_id.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesPosition = selectedPosition === 'All' || item.camera_position_no === selectedPosition;

      let matchesTime = true;
      if (timeFilter) {
        const detectionTime = item.detection_datetime.split(' ')[1];
        const [detectionHour, detectionMinute] = detectionTime.split(':').map(Number);
        const [filterHour, filterMinute] = timeFilter.split(':').map(Number);
        matchesTime = (detectionHour === filterHour && detectionMinute === filterMinute);
      }

      return matchesSearch && matchesPosition && matchesTime;
    });

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [data, searchTerm, selectedPosition, timeFilter]);

  // Reset position filter when search changes and current position is not available
  useEffect(() => {
    if (selectedPosition !== 'All' && !cameraPositions.includes(selectedPosition)) {
      setSelectedPosition('All');
    }
  }, [searchTerm, selectedPosition, cameraPositions]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  console.log("api ka response", data)

  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const handleNavigate = (item) => {
    navigate(`${process.env.PUBLIC_URL}/contractor-details/${item.employee_id}/${roleName}`, { state: { blacklisted: item?.blacklisted } })
  }
  return (
    <Card className="mb-4">
      <CardHeader className="bg-primary text-white d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Face Detections</h5>
      </CardHeader>
      <CardBody>
        <Row className="mb-3">
          <Col md="3">
            <FormGroup>
              <Label for="searchInput">Search by Employee ID</Label>
              <Input
                id="searchInput"
                type="text"
                placeholder="Enter employee ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>

        <div className="table-responsive">
          <Table bordered hover className="face-detection-table">
            <thead >
              <tr>
                <th style={{ textAlign: "center", fontWeight: "500", textTransform: "capitalize" }}>Image</th>
                <th style={{ textAlign: "center", fontWeight: "500", textTransform: "capitalize" }}>Employee ID</th>
                <th style={{ textAlign: "center", fontWeight: "500", textTransform: "capitalize" }}>Name</th>
                <th style={{ textAlign: "center", fontWeight: "500", textTransform: "capitalize" }}>Designation</th>
                <th style={{ textAlign: "center", fontWeight: "500", textTransform: "capitalize" }}>Black Listed</th>
                <th style={{ textAlign: "center", fontWeight: "500", textTransform: "capitalize" }}>Details</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item) => (
                  <tr key={item.log_id} style={{ textAlign: "center", fontWeight: "500", textTransform: "capitalize" }}>
                    <td style={{ width: "200px" }} className="text-center">
                      <img
                        src={item.face_image_url}
                        alt={`Face of ${item.employee_name}`}
                        className="face-thumbnail"
                        width="100"
                        height="100"
                        onClick={() => handleImageClick(item.face_image_url)}
                      />
                    </td>
                    <td>{item.employee_id}</td>
                    <td>{item.name}</td>
                    <td>{item.designation}</td>
                    {/**
                    <td>
                      <Badge
                        color={item.camera_position_no === "Gate In" ? "primary" : "success"}
                        pill
                      >
                        {item.camera_position_no}
                      </Badge>
                    </td>
                    <td>{formatDateTime(item.detection_datetime)}</td>
                     */}
                    <td>
                      <Badge
                        color={item.blacklisted ? "danger" : (item.sop_followed ? "success" : "warning")}
                        pill
                      >
                        {item.blacklisted ? "Blacklisted" : (item.sop_followed ? "Yes" : "No")}
                      </Badge>
                    </td>
                    <td>
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => handleNavigate(item)}
                      >
                        Details
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">No records found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {filteredData.length > itemsPerPage && (
          <PaginationComponent
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default FaceDetectionsTable;
